import React from "react";
import { Box, Paper, Typography } from "@mui/material";

/**
 * OverviewContainer wraps overview tables in a consistent Paper with:
 * - full width constrained by a max content width
 * - internal horizontal scroll zone for wide DataGrids
 * - optional title slot (children can include their own heading if preferred)
 */
export function OverviewContainer({
  title,
  children,
  maxWidth = 1800,
  fullHeight = false,
}) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      width="100%"
      sx={fullHeight ? { flex: 1, minHeight: 0 } : undefined}
    >
      <Paper
        variant="section"
        sx={{
          width: "100%",
          maxWidth,
          display: fullHeight ? "flex" : "block",
          flexDirection: fullHeight ? "column" : undefined,
          flex: fullHeight ? 1 : undefined,
          minHeight: fullHeight ? 0 : undefined,
        }}
      >
        {title && (
          <Typography variant="h5" sx={{ mb: 2 }}>
            {title}
          </Typography>
        )}
        <Box
          sx={{
            width: "100%",
            flex: fullHeight ? 1 : undefined,
            minHeight: fullHeight ? 0 : undefined,
            display: fullHeight ? "flex" : undefined,
            flexDirection: fullHeight ? "column" : undefined,
          }}
        >
          {children}
        </Box>
      </Paper>
    </Box>
  );
}
